// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notion-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.notion-modal-content {
  background-color: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 650px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}

.notion-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.notion-modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #333;
}

.notion-modal-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.notion-modal-close:hover {
  background-color: #f0f0f0;
  color: #333;
}

.notion-modal-body {
  padding: 24px;
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.notion-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: #5616ea;
}

.notion-loading p {
  margin-top: 16px;
  color: #666;
}

.notion-no-connections {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.notion-no-connections p {
  margin: 8px 0;
  color: #333;
  font-size: 1rem;
}

.notion-no-connections .notion-hint {
  color: #666;
  font-size: 0.875rem;
  margin-bottom: 24px;
}

.notion-account-selector {
  margin-bottom: 16px;
}

.notion-add-account-link {
  color: #5616ea;
  font-size: 0.875rem;
  cursor: pointer;
  display: inline-block;
  margin-top: 8px;
}

.notion-add-account-link:hover {
  text-decoration: underline;
}

.notion-file-browser {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  min-height: 300px;
  max-height: 400px;
}

.notion-search-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}

.notion-search-icon {
  color: #999;
  font-size: 0.85rem;
}

.notion-search-input {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 0.9rem;
  color: #333;
}

.notion-search-clear {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 2px 6px;
}

.notion-search-clear:hover {
  color: #333;
}

.notion-reselect-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 16px;
  background-color: #faf7ff;
  border-bottom: 1px solid #ece3ff;
}

.notion-reselect-hint {
  font-size: 0.8rem;
  color: #666;
}

.notion-reselect-btn {
  display: inline-flex;
  align-items: center;
  background: none;
  border: 1px solid #5616ea;
  color: #5616ea;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;
}

.notion-reselect-btn:hover {
  background-color: #f3eaff;
}

.notion-loading-files {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px;
  color: #5616ea;
}

.notion-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: #666;
  text-align: center;
}

.notion-empty .notion-hint {
  font-size: 0.8rem;
  color: #999;
  margin-top: 8px;
}

.notion-file-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px 0;
}

.notion-file-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.notion-file-item:hover {
  background-color: #f5f5f5;
}

.notion-file-item.selected {
  background-color: #f3eaff;
}

.notion-file-icon {
  margin-right: 12px;
  font-size: 1.1rem;
  color: #666;
}

.notion-file-name {
  flex: 1 1;
  font-size: 0.9rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notion-item-type-badge {
  margin-left: 8px;
  font-size: 0.7rem;
  font-weight: 600;
  color: #5616ea;
  background-color: #f3eaff;
  border-radius: 4px;
  padding: 2px 6px;
  flex-shrink: 0;
}

.notion-load-more {
  display: block;
  width: calc(100% - 32px);
  margin: 8px 16px;
  padding: 8px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  color: #5616ea;
  font-size: 0.85rem;
  cursor: pointer;
}

.notion-load-more:hover:not(:disabled) {
  background-color: #f3eaff;
}

.notion-load-more:disabled {
  cursor: default;
  opacity: 0.6;
}

.notion-selected-count {
  padding: 10px 16px;
  background-color: #f3eaff;
  color: #5616ea;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  border-top: 1px solid #e0d4f7;
}

.notion-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/components/NotionPickerModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":[".notion-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.notion-modal-content {\r\n  background-color: #fff;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 650px;\r\n  max-height: 85vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.notion-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.notion-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  color: #333;\r\n}\r\n\r\n.notion-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.25rem;\r\n  color: #666;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.notion-modal-close:hover {\r\n  background-color: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.notion-modal-body {\r\n  padding: 24px;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.notion-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px;\r\n  color: #5616ea;\r\n}\r\n\r\n.notion-loading p {\r\n  margin-top: 16px;\r\n  color: #666;\r\n}\r\n\r\n.notion-no-connections {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px 24px;\r\n  text-align: center;\r\n}\r\n\r\n.notion-no-connections p {\r\n  margin: 8px 0;\r\n  color: #333;\r\n  font-size: 1rem;\r\n}\r\n\r\n.notion-no-connections .notion-hint {\r\n  color: #666;\r\n  font-size: 0.875rem;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.notion-account-selector {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.notion-add-account-link {\r\n  color: #5616ea;\r\n  font-size: 0.875rem;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  margin-top: 8px;\r\n}\r\n\r\n.notion-add-account-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.notion-file-browser {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  min-height: 300px;\r\n  max-height: 400px;\r\n}\r\n\r\n.notion-search-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  background-color: #fafafa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.notion-search-icon {\r\n  color: #999;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.notion-search-input {\r\n  flex: 1;\r\n  border: none;\r\n  background: transparent;\r\n  outline: none;\r\n  font-size: 0.9rem;\r\n  color: #333;\r\n}\r\n\r\n.notion-search-clear {\r\n  background: none;\r\n  border: none;\r\n  color: #999;\r\n  cursor: pointer;\r\n  padding: 2px 6px;\r\n}\r\n\r\n.notion-search-clear:hover {\r\n  color: #333;\r\n}\r\n\r\n.notion-reselect-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding: 8px 16px;\r\n  background-color: #faf7ff;\r\n  border-bottom: 1px solid #ece3ff;\r\n}\r\n\r\n.notion-reselect-hint {\r\n  font-size: 0.8rem;\r\n  color: #666;\r\n}\r\n\r\n.notion-reselect-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background: none;\r\n  border: 1px solid #5616ea;\r\n  color: #5616ea;\r\n  border-radius: 6px;\r\n  padding: 5px 10px;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.notion-reselect-btn:hover {\r\n  background-color: #f3eaff;\r\n}\r\n\r\n.notion-loading-files {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 48px;\r\n  color: #5616ea;\r\n}\r\n\r\n.notion-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px;\r\n  color: #666;\r\n  text-align: center;\r\n}\r\n\r\n.notion-empty .notion-hint {\r\n  font-size: 0.8rem;\r\n  color: #999;\r\n  margin-top: 8px;\r\n}\r\n\r\n.notion-file-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 8px 0;\r\n}\r\n\r\n.notion-file-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.notion-file-item:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.notion-file-item.selected {\r\n  background-color: #f3eaff;\r\n}\r\n\r\n.notion-file-icon {\r\n  margin-right: 12px;\r\n  font-size: 1.1rem;\r\n  color: #666;\r\n}\r\n\r\n.notion-file-name {\r\n  flex: 1;\r\n  font-size: 0.9rem;\r\n  color: #333;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.notion-item-type-badge {\r\n  margin-left: 8px;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n  background-color: #f3eaff;\r\n  border-radius: 4px;\r\n  padding: 2px 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.notion-load-more {\r\n  display: block;\r\n  width: calc(100% - 32px);\r\n  margin: 8px 16px;\r\n  padding: 8px;\r\n  background-color: #f5f5f5;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  color: #5616ea;\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.notion-load-more:hover:not(:disabled) {\r\n  background-color: #f3eaff;\r\n}\r\n\r\n.notion-load-more:disabled {\r\n  cursor: default;\r\n  opacity: 0.6;\r\n}\r\n\r\n.notion-selected-count {\r\n  padding: 10px 16px;\r\n  background-color: #f3eaff;\r\n  color: #5616ea;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  border-top: 1px solid #e0d4f7;\r\n}\r\n\r\n.notion-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-top: 16px;\r\n  padding-top: 16px;\r\n  border-top: 1px solid #e0e0e0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
